import { axiosAPIUrl, Parameter } from '@/api/index'
import { ShopGoodsInfoDto } from '@/api/industryMall'


// 底部导航模块
export class TabDto {
  applicationName?: string // 模块名称
  applicationLogo?: string // 应用图片链接
  sortId?: number // 序号
  route?: string // 路由
  isShow?: boolean
}

/**
 *  4.2 获取商品列表(getGoodsList) pc
 * @param parameter
 */
export function getGoodsList(parameter: Parameter = {}, showLoading = false) {
  return axiosAPIUrl<Ajax.Response<Ajax.ListData<ShopGoodsInfoDto>>>({
    url: '/cykjStoreGoods/GetGoodsInfo/getGoodsList',
    method: 'post',
    data: parameter,
    extraParams: { showLoading }
  })
}

// 1.1 获取商品分类列表(getGoodsCategoryList)
export function getPcGoodsCategoryList (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjStoreGoods/shopping/getGoodsCategoryList',
    method: 'post',
    data: parameter
  })
}

// GM011批量套餐上下架
export function batchUpdatePackage (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjStoreGoods/GM/batchUpdatePackage',
    method: 'post',
    data: parameter
  })
}

/**               客户管理（SCM）            */
/**
 * @description 10.1 获取客户分类 (getStoreLevelManageList)
 * @param parameter
 * @returns
 */
export function getStoreLevelManageList (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<Ajax.ListData<any>>>({
    url: '/cykjoperation/SCM/getStoreLevelManageList',
    method: 'get',
    params: parameter
  })
}

/**            商品模块           */

/**
 * @description 4.9 获取套餐级别定价(getPackagePriceList)
 * @param parameter
 * @returns
 */
export function getPackagePriceList (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjStoreGoods/GetGoodsInfo/getPackagePriceList',
    method: 'get',
    params: parameter
  })
}

// GM012修改商品价格提交
export function modifyGoodsPriceSubmit (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjStoreGoods/GM/modifyGoodsPriceSubmit',
    method: 'post',
    data: parameter
  })
}

// 客户运营 1.1 FN001-获取常驻导航 getStoreUserNavbarList
export function getStoreUserNavbarList (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<Array<TabDto>>>({
    url: '/cykjoperation/FN/getStoreUserNavbarList',
    method: 'get',
    params: parameter,
    extraParams: { showLoading: false }
  })
}

// 客户运营 1.2 FN002-修改常驻导航 updateStoreUserNavbar
export function updateStoreUserNavbar (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjoperation/FN/updateStoreUserNavbar',
    method: 'post',
    data: parameter
  })
}

// 客户运营 1.3 FN003-获取常驻导航模板 getStoreUserNavbarTempletList
export function getStoreUserNavbarTempletList (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjoperation/FN/getStoreUserNavbarTempletList',
    method: 'get',
    params: parameter
  })
}

// 4.3 获取商品详情(getGoodsInfo) –商户
export function getGoodsInfo (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjStoreGoods/GetGoodsInfo/getGoodsInfo',
    method: 'get',
    params: parameter
  })
}

// 获取商品详情-商城分类
export function getTerraceGoodsCategoryList (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<Ajax.ListData<any>>>({
    url: '/channelPartner/PGC/getGoodsCategoryList',
    method: 'post',
    data: parameter
  })
}

// 1.30 判断公司类型(getCompanyType)
export function getCompanyType (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjoperation/companyManage/getCompanyType',
    method: 'get',
    params: parameter,
    extraParams: { showLoading: false }
  })
}
